import { NgModule }       from '@angular/core';
import { BrowserModule }  from '@angular/platform-browser';
import { FormsModule }    from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';

import { AppComponent }         from './app.component';
import { AppRoutingModule, routedComponents } from './app-routing.module';
import { TicketService }          from './Ticket/Services/ticket.service';
import {NgbModule} from '@ng-bootstrap/ng-bootstrap';
import { IsNumberValidator } from './validators/isNumber.validator';

@NgModule({
  imports: [
    BrowserModule,
    FormsModule,
    HttpClientModule,
    AppRoutingModule,
    NgbModule.forRoot()
  ],
  declarations: [
    AppComponent,
    routedComponents,
    IsNumberValidator,
  ],
  exports: [
    IsNumberValidator,
  ],
  providers: [
    TicketService
  ],
  bootstrap: [ AppComponent ]
})
export class AppModule {
}




// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/app.module.ts